import { DisaggregatedMetric, MetricPanelProps } from "../../services/types";
import { getSortedMetrics, getSvgMap } from "../../utils/dashboardUtils";
import MetricCard from "../metrics/MetricCard";
import MetricBarChart from "../charts/MetricBarChart";
import ChartHeader from "../metrics/ChartHeader";

const EconomyMetrics = ({ indicators, categorizedData, geoDetails, tab, geoTag, selectionActive }: MetricPanelProps) => {   
    const sortedMetrics = getSortedMetrics(tab, categorizedData);
    console.log("economy data:", sortedMetrics);

    if (!indicators || indicators.length === 0) {
        return <div className="flex items-center justify-center text-color-cai-dashboard">No metrics available for {tab}.</div>;
    }

    // Define metrics for order
    const e: DisaggregatedMetric[] = sortedMetrics[0];
    const employment = indicators?.find(i => i.id === 1222);

    return (
        <>
            <div className="grid grid-cols-2 xxs:grid-cols-3 gap-4 place-items-start">
                {e?.map(metric => (
                    <MetricCard
                        key={metric.id}
                        metric={metric}
                        width="w-full"
                        svg={getSvgMap(metric.id)}
                        disaggData={indicators}
                        geoDetails={geoDetails}
                        geoTag={geoTag}
                        selectionActive={selectionActive}
                    />
                ))}
            </div>

            {employment &&
                <div className="w-full my-4">
                    <ChartHeader
                        key={employment.id}
                        id={employment.id}
                        title={employment.name}
                        svg={getSvgMap(employment.id)}
                        disaggData={indicators}
                        geoDetails={geoDetails}
                        geoTag={geoTag}
                        selectionActive={selectionActive}
                    />
                    <MetricBarChart metric={employment} height="h-96" background="bg-transparent"/>
                </div>
            }
        </>
    );
}

export default EconomyMetrics;